import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'), {
    ssr: false,
});
export default SvgIcon;
export const EFEmailValiError = dynamic(() => import('./Icon/EFEmailValiError'), {
    ssr: false,
});
export const EFFixedWinClose = dynamic(() => import('./Icon/EFFixedWinClose'), {
    ssr: false,
});
export const EFProductWinAdd = dynamic(() => import('./Icon/EFProductWinAdd'), {
    ssr: false,
});
export const EFProductIcon1 = dynamic(() => import('./Icon/EFProductIcon1'), {
    ssr: false,
});
export const EFEmailValiInfo = dynamic(() => import('./Icon/EFEmailValiInfo'), {
    ssr: false,
});
export const EFMicrowave = dynamic(() => import('./Icon/EFMicrowave'), {
    ssr: false,
});
export const EFMicrowaveH5 = dynamic(() => import('./Icon/EFMicrowaveH5'), {
    ssr: false,
});
export const EFWaterHeater = dynamic(() => import('./Icon/EFWaterHeater'), {
    ssr: false,
});
export const EFWaterHeaterH5 = dynamic(() => import('./Icon/EFWaterHeaterH5'), {
    ssr: false,
});
export const EFLaptop = dynamic(() => import('./Icon/EFLaptop'), {
    ssr: false,
});
export const EFInductionCooker = dynamic(() => import('./Icon/EFInductionCooker'), {
    ssr: false,
});
export const EFLight = dynamic(() => import('./Icon/EFLight'), {
    ssr: false,
});
export const EFLightH5 = dynamic(() => import('./Icon/EFLightH5'), {
    ssr: false,
});
export const EFCrockpot = dynamic(() => import('./Icon/EFCrockpot'), {
    ssr: false,
});
export const EFCrockpotH5 = dynamic(() => import('./Icon/EFCrockpotH5'), {
    ssr: false,
});
export const EFAirConditioner = dynamic(() => import('./Icon/EFAirConditioner'), {
    ssr: false,
});
export const EFAirConditionerH5 = dynamic(() => import('./Icon/EFAirConditionerH5'), {
    ssr: false,
});
export const EFTV = dynamic(() => import('./Icon/EFTV'), {
    ssr: false,
});
export const EFFridge = dynamic(() => import('./Icon/EFFridge'), {
    ssr: false,
});
export const EFCustom = dynamic(() => import('./Icon/EFCustom'), {
    ssr: false,
});
export const EFCustomH5 = dynamic(() => import('./Icon/EFCustomH5'), {
    ssr: false,
});
export const EFVideoPlayer = dynamic(() => import('./Icon/EFVideoPlayer'), {
    ssr: false,
});
export const EFVideoPlayForCN = dynamic(() => import('./Icon/EFVideoPlayForCN'), {
    ssr: false,
});
export const EFSmartGenerator = dynamic(() => import('./Icon/EFSmartGenerator'), {
    ssr: false,
});
export const EFSmartGeneratorH5 = dynamic(() => import('./Icon/EFSmartGeneratorH5'), {
    ssr: false,
});
export const EFShorePower = dynamic(() => import('./Icon/EFShorePower'), {
    ssr: false,
});
export const EFAlternatorH5 = dynamic(() => import('./Icon/EFAlternatorH5'), {
    ssr: false,
});
export const EFAlternator = dynamic(() => import('./Icon/EFAlternator'), {
    ssr: false,
});
export const EFShorePowerH5 = dynamic(() => import('./Icon/EFShorePowerH5'), {
    ssr: false,
});
export const EFShorePowerAU = dynamic(() => import('./Icon/EFShorePowerAU'), {
    ssr: false,
});
export const EFSolarPower = dynamic(() => import('./Icon/EFSolarPower'), {
    ssr: false,
});
export const EFSolarPowerH5 = dynamic(() => import('./Icon/EFSolarPowerH5'), {
    ssr: false,
});
export const EFHighTemperature = dynamic(() => import('./Icon/EFHighTemperature'), {
    ssr: false,
});
export const EFHighTemperatureH5 = dynamic(() => import('./Icon/EFHighTemperatureH5'), {
    ssr: false,
});
export const EFLowTemperature = dynamic(() => import('./Icon/EFLowTemperature'), {
    ssr: false,
});
export const EFLowTemperatureH5 = dynamic(() => import('./Icon/EFLowTemperatureH5'), {
    ssr: false,
});
export const EFElectricPass = dynamic(() => import('./Icon/EFElectricPass'), {
    ssr: false,
});
export const EFElectricPassH5 = dynamic(() => import('./Icon/EFElectricPassH5'), {
    ssr: false,
});
export const EFPowerLoss = dynamic(() => import('./Icon/EFPowerLoss'), {
    ssr: false,
});
export const EFPowerLossH5 = dynamic(() => import('./Icon/EFPowerLossH5'), {
    ssr: false,
});
export const EFSafer = dynamic(() => import('./Icon/EFSafer'), {
    ssr: false,
});
export const EFSaferH5 = dynamic(() => import('./Icon/EFSaferH5'), {
    ssr: false,
});
export const EFSwiperLeftBtn = dynamic(() => import('./Icon/EFSwiperLeftBtn'), {
    ssr: false,
});
export const EFSwiperRightBtn = dynamic(() => import('./Icon/EFSwiperRightBtn'), {
    ssr: false,
});
export const EFReplay = dynamic(() => import('./Icon/EFReplay'), {
    ssr: false,
});
export const EFRightArrow = dynamic(() => import('./Icon/EFRightArrow'), {
    ssr: false,
});
export const EFEdit = dynamic(() => import('./Icon/EFEdit'), {
    ssr: false,
});
export const EFKitC5Svg = dynamic(() => import('./Icon/EFKitC5Svg'), {
    ssr: false,
});
export const EFKitC3SvgUs = dynamic(() => import('./Icon/EFKitC3SvgUs'), {
    ssr: false,
});
export const EFKitC3SvgAu = dynamic(() => import('./Icon/EFKitC3SvgAu'), {
    ssr: false,
});
export const EFKitC3SvgH5Us = dynamic(() => import('./Icon/EFKitC3SvgH5Us'), {
    ssr: false,
});
export const EFKitC3SvgH5Au = dynamic(() => import('./Icon/EFKitC3SvgH5Au'), {
    ssr: false,
});
export const EFKitH1SvgPc = dynamic(() => import('./Icon/EFKitH1SvgPc'), {
    ssr: false,
});
export const EFKitH2SvgPc = dynamic(() => import('./Icon/EFKitH2SvgPc'), {
    ssr: false,
});
export const EFKitH3SvgPc = dynamic(() => import('./Icon/EFKitH3SvgPc'), {
    ssr: false,
});
export const EFKitH1SvgH5 = dynamic(() => import('./Icon/EFKitH1SvgH5'), {
    ssr: false,
});
export const EFKitH2SvgH5 = dynamic(() => import('./Icon/EFKitH2SvgH5'), {
    ssr: false,
});
export const EFKitH3SvgH5 = dynamic(() => import('./Icon/EFKitH3SvgH5'), {
    ssr: false,
});
export const EFKitC6SvgPc = dynamic(() => import('./Icon/EFKitC6SvgPc'), {
    ssr: false,
});
export const EFKitC6SvgH5 = dynamic(() => import('./Icon/EFKitC6SvgH5'), {
    ssr: false,
});
export const EFKitC7SvgPc = dynamic(() => import('./Icon/EFKitC7SvgPc'), {
    ssr: false,
});
export const EFKitC7SvgH5 = dynamic(() => import('./Icon/EFKitC7SvgH5'), {
    ssr: false,
});
export const EFModalOpenSvgH5 = dynamic(() => import('./Icon/EFModalOpenSvgH5'), {
    ssr: false,
});
export const EFModalOpenSvgWhiteH5 = dynamic(() => import('./Icon/EFModalOpenSvgWhiteH5'), {
    ssr: false,
});
export const EFModalCloseSvgH5 = dynamic(() => import('./Icon/EFModalCloseSvgH5'), {
    ssr: false,
});
export const EFModalCloseBlackSvgH5 = dynamic(() => import('./Icon/EFModalCloseBlackSvgH5'), {
    ssr: false,
});
export const EFIconMoreH5 = dynamic(() => import('./Icon/EFIconMoreH5'), {
    ssr: false,
});
export const EFSolarPanel = dynamic(() => import('./Icon/EFSolarPanel'), {
    ssr: false,
});
export const EFAffirm = dynamic(() => import('./Icon/EFAffirm'), {
    ssr: false,
});
